// src/index.js — Simplified CRA + Clerk for /app subpath
// Imports App from App.js (not MainApp)
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { ClerkProvider } from "@clerk/clerk-react";

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
console.log("Publishable Key:", process.env.REACT_APP_CLERK_PUBLISHABLE_KEY);

if (!PUBLISHABLE_KEY) {
  console.error("❌ Clerk publishableKey is missing. Check your .env files.");
  throw new Error("Missing REACT_APP_CLERK_PUBLISHABLE_KEY");
}

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error('Root element "#root" not found in index.html');
}

createRoot(rootEl).render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      signInFallbackRedirectUrl="/app"
      signUpFallbackRedirectUrl="/app"
      afterSignInUrl="/app"
      afterSignUpUrl="/app"
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>
);
